import React, { useCallback } from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { styles } from './styles';

export default function ProgramModeSelection({ activeMode, setMode }) {
  const classes = styles();

  const handleModeChange = useCallback((event, newValue) => {
    setMode((oldValue) => (newValue ? newValue : oldValue));
  }, []);

  return (
    <ToggleButtonGroup
      className={classes.root}
      classes={{
        grouped: classes.grouped,
        groupedHorizontal: classes.groupedHorizontal,
      }}
      value={activeMode}
      exclusive
      onChange={handleModeChange}
    >
      <ToggleButton
        disableRipple
        value="my"
        classes={{ root: classes.toggleRoot, selected: classes.toggleSelected }}
      >
        {'My Programs'}
      </ToggleButton>
      <ToggleButton
        disableRipple
        value="all"
        classes={{ root: classes.toggleRoot, selected: classes.toggleSelected }}
      >
        {'All Programs'}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
